import { Component, OnInit } from '@angular/core';

import { Member } from '@asambleas-models/member.model';

import { GeneralService } from '@asambleas-services/general/general.service';
import { MinisterService } from '@asambleas-services/minister/minister.service';
import { MemberService } from '@asambleas-services/member/member.service';


/**
 * Contenedor que muestra la información de perfil del usuario
 */
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    member: Member = null;

    constructor(
        private memberService: MemberService,
        public generalService: GeneralService
        ) { }


    ngOnInit() {
        this.member = this.memberService.getUser();
    }


}



// WEBPACK FOOTER //
// ./src/app/admin/pages/home/home.component.ts